import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Slices } from "src/constants";

interface IAuthenticatedProps extends React.PropsWithChildren {
  authenticatedRoles: string[];
}

const Authenticated: React.FC<IAuthenticatedProps> = ({
  authenticatedRoles,
  children,
}) => {
  const { user } = useSelector(
    (state: any) => state[Slices.LOGIN_INFORMATION]
  );

  // console.log('user from authenticated', user)
  const [isAuthenticated, setisAuthenticated] = useState(false);

  useEffect(() => {

    if(user){
      const allowed = authenticatedRoles.includes(user?.role?.name.trim())
      setisAuthenticated(allowed);
    }
    
  }, [authenticatedRoles, user]);

  return <>{isAuthenticated ? children : null}</>;
  // return <></>
};

export default Authenticated;
